export default __webpack_public_path__ + "static/media/walletconnect.8c21fe21.svg";